<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Lista de Serviços</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Novo Serviço"
          icon="assets/add.svg"
          (click)="navegarNovaEntrada()"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="this.exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem de Serviços</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getServicos()">
            <div class="table-filters">
              <app-input
                label="Cód. Serviço"
                placeholder="Digite aqui"
                name="FK_SRVC_ENTR"
                formControlName="FK_SRVC_ENTR"
                width="100%"></app-input>
              <app-input
                label="ID Empresa"
                placeholder="Digite aqui"
                name="FK_EPSA"
                formControlName="FK_EPSA"
                width="100%"></app-input>
              <app-input
                label="Motorista"
                placeholder="Digite aqui"
                name="NM_MTRT"
                formControlName="NM_MTRT"
                width="100%"></app-input>
              <app-input
                label="Placa do Cavalo"
                placeholder="Digite aqui"
                name="TX_PLCA_CAVA"
                formControlName="TX_PLCA_CAVA"
                mask="AAA-0A00"
                width="100%"></app-input>
              <app-input
                type="select"
                label="Situação"
                name="FL_CNCL"
                formControlName="FL_CNCL"
                [selectData]="situacaoOptions"
                (ngModelChange)="onSituacaoChange($event)"
                width="100%"></app-input>
              <span></span>
              <app-input
                type="datetime-local"
                label="Data do Início"
                placeholder="Digite aqui"
                name="DT_SRVC_ENTR_INIC"
                formControlName="DT_SRVC_ENTR_INIC"
                width="100%"></app-input>
              <app-input
                label="Data Fim"
                type="datetime-local"
                width="100%"
                class="pesquisa"
                name="DT_SRVC_ENTR_FIM"
                formControlName="DT_SRVC_ENTR_FIM"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Cód. Serviço"
        placeholder="Digite aqui"
        name="FK_SRVC_ENTR"
        formControlName="FK_SRVC_ENTR"
        width="100%"></app-input>
      <app-input
        label="ID Empresa/Motorista"
        placeholder="Digite aqui"
        name="FK_EPSA"
        formControlName="FK_EPSA"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        mask="AAA-0A00"
        width="100%"></app-input>
      <app-input
        type="select"
        label="Situação"
        name="FL_CNCL"
        formControlName="FL_CNCL"
        [selectData]="situacaoOptions"
        (ngModelChange)="onSituacaoChange($event)"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data do Início"
        placeholder="Digite aqui"
        name="DT_SRVC_ENTR_INIC"
        formControlName="DT_SRVC_ENTR_INIC"
        width="100%"></app-input>
      <app-input
        label="Data Fim"
        type="datetime-local"
        width="100%"
        class="pesquisa"
        name="DT_SRVC_ENTR_FIM"
        formControlName="DT_SRVC_ENTR_FIM"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
